class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  load(url) {
    return fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        return recommendations && recommendations.querySelector('li')
          ? recommendations.innerHTML
          : null;
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.load(this.dataset.url)
      .then(content => content || this.load(this.dataset.url.replace('intent=complementary', 'intent=related')))
      .then(content => {
        if (content) {
          this.innerHTML = content;
        } else {
          this.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
